import { instance } from '../app/instance';

/**
 * Get dashboard statistics
 * GET /api/admin/stats/dashboard
 */
export const getDashboardStats = async (params = {}) => {
  const response = await instance.get('/stats/dashboard', { params });
  return response.data;
};

/**
 * Get trends statistics
 * GET /api/admin/stats/trends
 */
export const getTrends = async (params = {}) => {
  const response = await instance.get('/stats/trends', { params });
  return response.data;
};

/**
 * Get user demographics
 * GET /api/admin/stats/users/demographics
 */
export const getUserDemographics = async (params = {}) => {
  const response = await instance.get('/stats/users/demographics', { params });
  return response.data;
};

/**
 * Get expert performance stats
 * GET /api/admin/stats/experts/performance
 */
export const getExpertPerformance = async (params = {}) => {
  const response = await instance.get('/stats/experts/performance', { params });
  return response.data;
};

/**
 * Get finance detailed stats
 * GET /api/admin/stats/finance/detailed
 */
export const getFinanceDetailed = async (params = {}) => {
  const response = await instance.get('/stats/finance/detailed', { params });
  return response.data;
};

/**
 * Get complaint statistics
 * GET /api/admin/stats/complaints
 */
export const getComplaintStats = async (params = {}) => {
  const response = await instance.get('/stats/complaints', { params });
  return response.data;
};

/**
 * Get consultation analytics
 * GET /api/admin/stats/consultations/analytics
 */
export const getConsultationAnalytics = async (params = {}) => {
  const response = await instance.get('/stats/consultations/analytics', { params });
  return response.data;
};

/**
 * Get chat analytics
 * GET /api/admin/stats/chats/analytics
 */
export const getChatAnalytics = async (params = {}) => {
  const response = await instance.get('/stats/chats/analytics', { params });
  return response.data;
};

/**
 * Get support statistics
 * GET /api/admin/stats/support
 */
export const getSupportStats = async (params = {}) => {
  const response = await instance.get('/stats/support', { params });
  return response.data;
};

/**
 * Get anxiety statistics
 * GET /api/admin/stats/anxiety
 */
export const getAnxietyStats = async (params = {}) => {
  const response = await instance.get('/stats/anxiety', { params });
  return response.data;
};

/**
 * Get promo code statistics
 * GET /api/admin/stats/promo
 */
export const getPromoStats = async (params = {}) => {
  const response = await instance.get('/stats/promo', { params });
  return response.data;
};

/**
 * Get partner statistics
 * GET /api/admin/stats/partners
 */
export const getPartnerStats = async (params = {}) => {
  const response = await instance.get('/stats/partners', { params });
  return response.data;
};

/**
 * Get live metrics
 * GET /api/admin/stats/live
 */
export const getLiveMetrics = async (params = {}) => {
  const response = await instance.get('/stats/live', { params });
  return response.data;
};
